export interface UfabetGameModalInitialStateProps {
  isOpen: boolean;
}

export enum ufabetGameModalActionTypes {
  OPEN_UFABET_GAME_MODAL = "OPEN_UFABET_GAME_MODAL",
  CLOSE_UFABET_GAME_MODAL = "CLOSE_UFABET_GAME_MODAL",
}

const initialState: UfabetGameModalInitialStateProps = {
  isOpen: false,
};

export default function ufabetGameModal(
  state = initialState,
  action: { type: ufabetGameModalActionTypes; payload?: any }
): UfabetGameModalInitialStateProps {
  switch (action.type) {
    case ufabetGameModalActionTypes.OPEN_UFABET_GAME_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case ufabetGameModalActionTypes.CLOSE_UFABET_GAME_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
